import { setToastsError } from '../redux/actions/common';
import { setEdlp, setFiftyDiscount, setNbpbkbn, setPriceValid, setProhibitedItem, setShowTableLimitOver } from '../redux/actions/modal';
import { setMaintenance } from '../redux/actions/storage';
import { ErrorMessage } from '../services';

const apiErrorHandler = (dispatch, error, disconnectMessage) => {
    dispatch(setMaintenance(false));
    let errorMessage =
        error?.status === 500 || !error
            ? (disconnectMessage ?? '通信が失敗しました。再度実行をお願いします。')
            : error.status === 401
              ? '認証エラー'
              : (error.body?.message ?? disconnectMessage ?? '通信が失敗しました。再度実行をお願いします。');

    if (error.status === 400) {
        if (error.body.errors?.length > 0 && error.body.errors[0].errorType === 'OTHER') {
            errorMessage = error.body.errors[0].message;
        }
    }

    switch (error.status) {
        case 401:
            window.location.href = '/login';
            break;
        case 503:
            if (error.body?.errors?.some((item) => item.errorType === 'MAINTENANCE')) {
                dispatch(setMaintenance(true));
            }
            break;
        default:
            dispatch(setToastsError(errorMessage));
            break;
    }
};

export const checkError = (error, errorType, exceptions = []) => {
    return error.body?.errors?.some((item) => item.errorType === errorType) && !exceptions.some((item) => item === errorType);
};

export const getItems = (error, items, errorType) => {
    const indexes = error.body?.errors?.filter((item) => errorType === item.errorType).map((item) => item.recordIndex);

    const data = indexes.map((index) => items[index]);
    return data;
};

export const apiValidationErrorHandler = (dispatch, error, items, disconnectMessage, exceptions = []) => {
    // エラーメッセージ表示
    if (checkError(error, 'MAINTENANCE', exceptions)) {
        apiChangeRequestErrorHandler(dispatch, error, disconnectMessage);
    }

    // 下限値チェック:下限値を下回っています。
    if (checkError(error, ErrorMessage.errorType.UNDER_LOWER_LIMIT, exceptions)) {
        const limitOverItems = getItems(error, items, ErrorMessage.errorType.UNDER_LOWER_LIMIT);
        if (limitOverItems.length > 0) {
            dispatch(
                setShowTableLimitOver({
                    isShow: true,
                    items: limitOverItems,
                }),
            );
            return;
        }
    }
    // 禁止商品チェック:登録禁止商品があります。
    if (checkError(error, ErrorMessage.errorType.PROHIBITED_ITEM, exceptions)) {
        const prohibitedItems = getItems(error, items, ErrorMessage.errorType.PROHIBITED_ITEM);
        if (prohibitedItems.length > 0) {
            dispatch(
                setProhibitedItem({
                    isShow: true,
                    items: prohibitedItems,
                }),
            );
            return;
        }
    }
    // PB・留型商品チェック:PB・留型商品は登録できません。
    if (checkError(error, ErrorMessage.errorType.PBLE_ITEM, exceptions)) {
        const nbpbkbnItems = getItems(error, items, ErrorMessage.errorType.PBLE_ITEM);
        if (nbpbkbnItems.length > 0) {
            dispatch(
                setNbpbkbn({
                    isShow: true,
                    items: nbpbkbnItems,
                }),
            );
            return;
        }
    }
    // 更徳・超目チェック
    if (checkError(error, ErrorMessage.errorType.SALE_PRODUCT, exceptions)) {
        const priceValidItems = getItems(error, items, ErrorMessage.errorType.SALE_PRODUCT);
        if (priceValidItems.length > 0) {
            dispatch(
                setPriceValid({
                    isShow: true,
                    items: priceValidItems,
                }),
            );
            return;
        }
    }
    // EDLPチェック
    if (checkError(error, ErrorMessage.errorType.OVER_EDLP, exceptions)) {
        const edlpItems = getItems(error, items, ErrorMessage.errorType.OVER_EDLP);
        if (edlpItems.length > 0) {
            dispatch(
                setEdlp({
                    isShow: true,
                    items: edlpItems,
                }),
            );
            return;
        }
    }
    // 50%乖離チェック
    if (checkError(error, ErrorMessage.errorType.FIFTY_DISCOUNT, exceptions)) {
        const fiftyDiscountItems = getItems(error, items, ErrorMessage.errorType.FIFTY_DISCOUNT);
        if (fiftyDiscountItems.length > 0) {
            dispatch(
                setFiftyDiscount({
                    isShow: true,
                    items: fiftyDiscountItems,
                }),
            );
            return;
        }
    }
    // エラーメッセージ表示
    if (checkError(error, ErrorMessage.errorType.OTHER, exceptions)) {
        apiChangeRequestErrorHandler(dispatch, error, disconnectMessage);
    }
};

export const apiChangeRequestErrorHandler = (dispatch, error, disconnectMessage) => {
    dispatch(setMaintenance(false));
    const errorMessages =
        error?.status === 500 || !error
            ? [disconnectMessage ?? '通信が失敗しました。再度実行をお願いします。']
            : error.status === 401
              ? '認証エラー'
              : error.body?.errors?.map((item) => item.message).length > 0
                ? error.body?.errors?.map((item) => item.message)
                : [disconnectMessage ?? '通信が失敗しました。再度実行をお願いします。'];

    switch (error.status) {
        case 401:
            window.location.href = '/login';
            break;
        case 503:
            if (error.body?.errors?.some((item) => item.errorType === 'MAINTENANCE')) {
                dispatch(setMaintenance(true));
            }
            break;
        default:
            errorMessages.map((message) => {
                dispatch(setToastsError(message));
            });
            break;
    }
};

export default apiErrorHandler;
